/**
 * 自动登录（免登录）
 */
import axios from 'axios';
import CryptoJS from 'crypto-js';
import qs from 'qs';

export function auth(user) {
    return new Promise( (resolve, reject) => {
        let data = {
            UserName: user,
            Password: computepwdstr(
              'Abc123@Biaddti'+'MK4ZJF10PRO19*#8',
              CryptoJS
            )
        };
        let postdata = qs.stringify(data);
        axios({
            method: "post",
            url: `${window.pubilc_config.webserverurl}/api/User/Home/Login`,
            data: postdata
        }).then(res =>{
            if (res.data.Ret == -1) {
                console.log('auth', res.data.Msg)
                reject();
            } else if (res.data.Ret == 1 && res.data.Data) {
                window.localStorage.removeItem("Token");
                let _tval = res.data.Data.token;
                window.localStorage.setItem("Token", _tval);
                resolve('OK')
            }
        }).catch(x =>{
            console.log('auth', x)
            reject();
        })
    });
}

// 对称加密算法
// json.input   输入的明文
// json.key     加密密钥
// return value 正常时返回：加密后的密码，异常时返回-1

function SymmetricEncryption(json, CryptoJS) {

    // parameter tests
    if (!json || !json.input || !json.key) {
        console.warn("json, json.input and json.key are not allow null!");
        return -1;
    }

    // 由于 key 小于16位会有问题，需要额外处理 key
    if (json.key.length == 0) {
        console.warn("json.length should not be zero!");
        return -1;
    }
    while (json.key.length < 16) {
        json.key = json.key + json.key;
    }
    // //由于 key 小于16位会有问题，需要额外处理 key

    //var CryptoJS = Vue.prototype.$CryptoJS;

    var KEY = json.key; //32位
    var IV = "*BIM19FF4KMY0R8*"; //16位
    var key = CryptoJS.enc.Utf8.parse(KEY);
    var iv = CryptoJS.enc.Utf8.parse(IV);

    var encrypted = "";

    var srcs = CryptoJS.enc.Utf8.parse(json.input);
    encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.ciphertext.toString(); //5c1b2248cb4ba581472afab0702518cc
}
// //对称加密算法

function computepwdstr(pwdorigin, _this_CryptoJS) {
    var afterpwd = SymmetricEncryption({
        input: pwdorigin,
        key: 'MK4ZJF10PRO19*#8'
    }, _this_CryptoJS);
    return afterpwd;
}